<!-- warning dialog -->
<app-common-modal #reloadNetPriceModal class="modal-style"
                  [title]="'T_PRICE_NET_PRICE_LOADED_TITLE' | translate"
                  [name]="'T_PRICE_NET_PRICE_LOADED_TITLE' | translate"
                  [description]="netPriceModalMessage | translate" [acceptInnerHtml]="true"
                  [twoButtonsDialogs]="false" [closable]="false"
                  (onClickOkButton)="goToProjectPage()">
</app-common-modal>
